import { render, staticRenderFns } from "./chooseLabelProduct.vue?vue&type=template&id=479ac168"
import script from "./chooseLabelProduct.vue?vue&type=script&lang=js"
export * from "./chooseLabelProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports